module.exports = __webpack_public_path__ + "static/channels-small-13ab708859d42ca6da0e9a32e2af6b9c.svg";